import { Page } from '@/core/architecture'

import { ConsoleEventsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEvents Page
 * Implemented as a practical sample.
 */
export const ConsoleEvents: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleEventsTemplate state={state} {...actions} />
}
